<template>
  <v-card>
    <v-card-title v-if="options.title">
      <span class="headline">{{ options.title }}</span>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text>
      <ValidationObserver
        ref="form"
        tag="form"
        @submit.prevent="save"
      >
        <ValidationProvider
          rules="required"
          vid="school_id"
          :name="$t('fields.school').toLowerCase()"
          v-slot="{ errors }"
        >
        <AutoComplete
          v-model="form.school_id"
          key-value="id"
          key-name="fullname"
          enable-chips
          enable-clearable
          enable-autofocus
          :items="schools"
          :label="$t('fields.school')"
          @search="searchSchools"
          @input="fetchSchoolLocation"
          :loading="loading"
          :delay="900"
          :errors="errors"
        >
        </AutoComplete>
        </ValidationProvider>

        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left"></th>
                <th class="text-left">{{ $t('fields.code') }}</th>
                <th class="text-left">{{ $t('fields.city') }}</th>
                <th class="text-left">{{ $t('fields.address') }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in schoolsLocations" :key="item.id">
                <td>
                  <ValidationProvider
                    rules="required"
                    vid="school_location_id"
                    :name="$t('fields.school_location').toLowerCase()"
                    v-slot="{ errors }"
                  >
                  <v-radio-group
                    v-model="form.school_location_id"
                    :error-messages="errors"
                  >
                    <v-radio :value="item.id"></v-radio>
                  </v-radio-group>
                  </ValidationProvider>
                </td>
                <td>{{ item.code }}</td>
                <td>{{ item.city }}</td>
                <td>{{ item.street }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>

    </ValidationObserver>
    </v-card-text>
    <v-card-actions>
      <v-btn @click="save" color="primary">{{ $t('SAVE') }}</v-btn>
      <v-btn @click="cancel">{{ $t('CANCEL') }}</v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
  import { mapActions, mapState } from 'vuex';

  import { schoolsService } from '../../../utils/services/schools.service';
  import { schoolsLocationsService } from '../../../utils/services/schoolsLocations.service';
  import AutoComplete from '../../shared/Inputs/AutoComplete';

  export default {
    name: 'SchoolPropagandistModal',
    components: { AutoComplete },
    data() {
      return {
        searchSchool: null,
        stored: null,
        schools: [],
        schoolsLocations: [],
        form: {
          propagandist_id: null,
          school_id: null,
          school_location_id: null,
        },
        loading: false,
      };
    },
    computed: {
      ...mapState('modal', ['options', 'data']),
    },
    methods: {
      ...mapActions('alert', ['showToast']),
      ...mapActions('modal', ['hideModal', 'loadingModal']),
      async save() {
        const isValid = await this.$refs.form.validate();
        if (isValid) {
            if (this.options.onSave) {
              this.loadingModal(true);
              this.options.onSave(
                this.form,
                this.errors,
              )
              .then(() => {
                  this.loadingModal(false);
              })
              .catch(error => {
                  this.handleError(error, this.errors);
              });
            }
        }
      },
      cancel() {
        this.hideModal({});
      },
      async fetchSchools() {
        return schoolsService.index({
          filters: {
            search: this.searchSchool,
          },
        })
        .then(response => {
            this.schools = response.data.data;
        })
        .catch(error => {
            this.handleError(error, this.errors);
        });
      },

      async fetchSchoolLocation() {
        return schoolsLocationsService.index(this.form.school_id)
        .then(response => {
            this.schoolsLocations = response.data.data;
        })
        .catch(error => {
            this.handleError(error, this.errors);
        });
      },

      searchSchools(val) {
        this.searchSchool = val;
        this.fetchSchools();
      },

    },
    async created() {
      this.loadingModal(true);

      if (this.data.stored) {
        this.form.propagandist_id = this.data.stored.propagandist_id;
        if (this.data.stored.id) {
          this.form.id = this.data.stored.id;
        }
      }


      this.loadingModal(false);
    },
  };
</script>
